import request from '../utils/request';
//登录
export function doLogin(data) {
  return request({
    url: 'user/login.html',
    method: 'post',
    data
  })
}

//在学班级
export function toMyClassList(data) {
  return request({
    url: 'learning/toMyClassList.do',
    method: 'post',
    data
  })
}
//非整体报名下单一路学
export function ylxSingleAddOrder(data) {
  return request({
    url: 'learning/ylxSingleAddOrder',
    method: 'post',
    data
  })
}

//在学班级课程
export function toMyCourseList(data) {
  return request({
    url: '/learning/toMyCourseList.do',
    method: 'post',
    data
  })
}

//章节
export function toMyCourseWareList(data) {
  return request({
    url: 'learning/toMyCourseWareList.do',
    method: 'post',
    data
  })
}

//
export function toStudyMain(data) {
  return request({
    url: 'learning/toStudyMain.do',
    method: 'post',
    data
  })
}

//获取视频数据和目录
export function toStudy(data) {
  return request({
    url: 'learning/toStudy.do',
    method: 'post',
    data
  })
}

//记录时长
export function updateDBTrack(data) {
  return request({
    url: 'learning/updateDBTrack.do',
    method: 'post',
    data
  })
}

//获取用户信息
export function getUser(data) {
  return request({
    url: 'learning/getUser.do',
    method: 'post',
    data
  })
}

//获取学习中心地址
export function getUrl() {
  return request({
    url: 'learning/toMemberCenter.html',
    method: 'post',
  })
}

//获取TM监管规则
export function getTrainSupervision(data) {
  return request({
    url: 'learning/getTrainSupervision.html',
    method: 'post',
    data
  })
}

//获取验证码
export function getTmVerCode(data) {
  return request({
    url: 'learning/getTmVerCode.html',
    method: 'post',
    data
  })
}

//提交验证码
export function sendCodeAnswer(data) {
  return request({
    url: '/learning/sendCodeAnswer.html',
    method: 'post',
    data
  })
}

//验证公需课
export function toCheckGxkStudy(data) {
  return request({
    url: '/learning/toCheckGxkStudy.do',
    method: 'post',
    data
  })
}

//学时证明
export function toCreditZM(data) {
  return request({
    url: '/learning/toCreditZM.html',
    method: 'post',
    data
  });
}


//底部
export function toGetBottom(data) {
  return request({
    url: '/learning/toGetBottom.html',
    method: 'get',
    data
  });
}

//获取用户信息
export function getUserInfo(data) {
  return request({
    url: '/learning/getUserInfo.html',
    method: 'post',
    data
  });
}

//获取课程状态
export function toAllReadyBuy(data) {
  return request({
    url: 'learning/toAllReadyBuy.html',
    method: 'post',
    data
  });
}

//邀请新人链接
export function getShareUrl(data) {
  return request({
    url: '/user/getShareUrl',
    method: 'post',
    data:data
  });
}
//考试列表
export function toExamQuize(data) {
  return request({
    url: '/learning/toExamQuiz.do',
    method: 'post',
    data
  })
}

//试卷记录
export function toExamUQDetail(data) {
  return request({
    url: '/learning/toExamUQDetail.do',
    method: 'post',
    data
  })
}

//回显试卷
export function toPreview(data) {
  return request({
    url: '/learning/toPreview.do',
    method: 'post',
    data
  })
}

//获取题目
export function toJoinExam(data) {
  return request({
    url: '/learning/toJoinExam.do',
    method: 'post',
    data
  })
}

//提交试卷
export function handInNew(data) {
  return request({
    url: '/learning/handInNew.do',
    method: 'post',
    data
  })
}


//保存用户选择答案
export function handIn(data) {
  return request({
    url: 'userQuiz/handIn.do',
    method: 'post',
    data
  })
}

//签到
export function doSign(data) {
  return request({
    url: 'userQuiz/doSign',
    method: 'post',
    data
  })
}


//人脸识别
export function compareAndSavePhoto(data) {
  return request({
    url: 'user/compareAndSavePhoto.do',
    method: 'post',
    data
  })
}

//获取用户考试状态
export function findUQDetailState(data) {
  return request({
    url: 'userQuiz/findUQDetailState.do',
    method: 'post',
    data
  })
}

//获取用户是否能考试
export function findUQState(data) {
  return request({
    url: '/learning/findUQState.do',
    method: 'post',
    data
  })
}

// //退出登录
// export function logout(data) {
//   return request({
//     url: 'logout',
//     method: 'post',
//     data
//   })
// }

// //获取学习中心地址
// export function getUrl() {
//   return request({
//     url: 'userQuiz/toMemberCenter.html',
//     method: 'post',
//   })
// }

